document.addEventListener('DOMContentLoaded', () => {
  const bars = document.querySelectorAll('[data-promo-countdown]');

  bars.forEach((bar) => {
    const endDate = new Date(bar.dataset.countdownEnd);
    if (Number.isNaN(endDate.getTime())) {
      bar.hidden = true;
      return;
    }

    const daysEl = bar.querySelector('[data-countdown-days]');
    const hoursEl = bar.querySelector('[data-countdown-hours]');
    const minutesEl = bar.querySelector('[data-countdown-minutes]');
    const secondsEl = bar.querySelector('[data-countdown-seconds]');

    const pad = (value) => String(value).padStart(2, '0');

    let intervalId;

    const tick = () => {
      const remainingMs = endDate.getTime() - Date.now();

      if (remainingMs <= 0) {
        bar.hidden = true;
        clearInterval(intervalId);
        return;
      }

      const totalSeconds = Math.floor(remainingMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    tick();
    intervalId = setInterval(tick, 1000);
  });
});
